import { Recordable } from '@mts-fe/types';
import { DAY_FORMAT, isArray, isObject, isString } from '..';

export function joinTimestamp<T extends boolean>(
  join: boolean,
  restful: T,
): T extends true ? string : object;

export function joinTimestamp(join: boolean, restful = false): string | object {
  if (!join) {
    return restful ? '' : {};
  }
  const now = Date.now();
  if (restful) {
    return `?_t=${now}`;
  }
  return { _t: now };
}

/**
 * @description: Format request parameter time
 */
// 部分字段需要保留前后空白符号
const noTrimKeys = ['requireExplain', 'materialInfo', 'richTextData'];
export function formatRequestDate(params: Recordable) {
  if (isArray(params)) {
    return params.map(formatRequestDate);
  }

  if (Object.prototype.toString.call(params) !== '[object Object]') {
    return;
  }

  for (const key in params) {
    const format = params[key]?.format ?? null;
    if (format && typeof format === 'function') {
      params[key] = params[key].format(DAY_FORMAT.DT);
    }
    if (isString(key)) {
      const value = params[key];
      if (value) {
        try {
          params[key] = noTrimKeys.includes(key) ? value : isString(value) ? value.trim() : value;
        } catch (error: any) {
          throw new Error(error);
        }
      } else if (typeof value === 'undefined' || value === '') {
        params[key] = null;
      }
    }
    if (isObject(params[key])) {
      formatRequestDate(params[key]);
    }
    if (isArray(params[key])) {
      params[key].map(formatRequestDate);
    }
  }
}
